import {
  EnvironmentProviders,
  inject,
  provideAppInitializer,
  Provider
} from '@angular/core';
import { ANALYTICS_SCRIPTS } from '../analytics.tokens';

export function provideAnalytics(features: Provider[][] = []): (Provider | EnvironmentProviders)[]  {
  return [
    ...features.flat(),
    provideAppInitializer(() => {
      inject(ANALYTICS_SCRIPTS, { optional: true });
    })
  ];
}
